import { useState, useEffect } from 'react';

const COOKIE_KEY = 'lara_cookie_consent';

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_KEY);
    if (!consent) {
      const timer = setTimeout(() => setVisible(true), 600);
      return () => clearTimeout(timer);
    }
    return undefined;
  }, []);

  const handleAccept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem(COOKIE_KEY, 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-50 animate-slide-up"
      style={{ animation: 'slideUp 0.4s ease-out' }}
    >
      <style>{`
        @keyframes slideUp {
          from { transform: translateY(100%); opacity: 0; }
          to { transform: translateY(0); opacity: 1; }
        }
      `}</style>

      <div className="bg-white border-t border-slate-200 px-4 py-5 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row md:items-start gap-4">
            {/* Icon + Text */}
            <div className="flex items-start gap-3 flex-1">
              <div className="w-10 h-10 flex items-center justify-center bg-slate-100 rounded-lg flex-shrink-0 mt-0.5">
                <i className="ri-shield-check-line text-slate-700 text-xl"></i>
              </div>
              <div>
                <p className="text-sm font-semibold text-slate-900 mb-1">
                  Questo sito utilizza cookie essenziali
                </p>
                <p className="text-xs text-slate-600 leading-relaxed max-w-2xl">
                  Utilizziamo esclusivamente cookie tecnici essenziali per il corretto funzionamento del sito. Non utilizziamo cookie di profilazione o marketing.{' '}
                  <button
                    type="button"
                    onClick={() => setShowDetails(!showDetails)}
                    className="text-slate-800 underline underline-offset-2 font-medium cursor-pointer hover:text-slate-600 transition-colors whitespace-nowrap"
                  >
                    {showDetails ? 'Nascondi dettagli' : 'Maggiori informazioni'}
                  </button>
                </p>

                {showDetails && (
                  <div className="mt-3 p-3 bg-slate-50 rounded-lg border border-slate-200 text-xs text-slate-600 leading-relaxed max-w-2xl">
                    <p className="font-semibold text-slate-800 mb-1">Cookie essenziali (sempre attivi)</p>
                    <ul className="space-y-1 list-disc list-inside">
                      <li><strong>lara_cookie_consent</strong> — Memorizza la tua scelta relativa ai cookie. Durata: 1 anno.</li>
                    </ul>
                    <p className="mt-2 text-slate-500">
                      Questi cookie sono strettamente necessari al funzionamento del sito e non possono essere disattivati. Non raccolgono dati personali identificabili.
                    </p>
                  </div>
                )}
              </div>
            </div>

            {/* Buttons */}
            <div className="flex items-center gap-3 flex-shrink-0 md:mt-1">
              <button
                type="button"
                onClick={handleReject}
                className="px-5 py-2.5 rounded-lg border border-slate-300 text-slate-700 text-sm font-medium hover:bg-slate-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                Rifiuta
              </button>
              <button
                type="button"
                onClick={handleAccept}
                className="px-5 py-2.5 rounded-lg bg-slate-800 text-white text-sm font-medium hover:bg-slate-900 transition-colors cursor-pointer whitespace-nowrap"
              >
                Accetta cookie essenziali
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
